import React, { useState, useEffect, Fragment, useRef } from "react";
import ReactDom, { unmountComponentAtNode, createPortal } from "react-dom";
import Form from "react-bootstrap/Form";
import { utils, ResponseCode, AddLogInAmplitude } from "../../utils/Utils";
import Leftpanel from "../../Layout/Sidebar/LeftPanel";
import NoRights from "../Common/NoRights";
import { AsyncAjaxGet, AsyncAjaxPost } from "../Common/AsyncAjaxService";
import Loader from "../Common/Loader";
import Alert from "react-bootstrap/Alert";
import FileUpload from "../Controls/FileUpload";
import { useSelector, useDispatch } from 'react-redux'
import VGPopUp from "../Controls/VGPopUp";
import {
  DeactivateWB
} from '../Slice/Business';
import useGenerateToken from "components/Hook/useGenerateToken";
import useSession from "components/Hook/useSession";

const GeneralSettings = (props) => {

  const { BusinessID, ReactBusinessId, ReactUserID, UserID, CDNURL, IsNewCustomWebSite, IsViewAllowed, IsModifyAllowed, CountryID, BuildInDomain, VagaroURL, AmplitudeBusinessID } = useSelector((state) => state.Business);
  const dispatch = useDispatch();

  const VagaroAPIEnum = {
    GetGeneralSettings: BusinessID + "/websitebuilders/generalsettings",
    GetUploadImage: BusinessID + "/websitebuilders/uploadsavegeneralsettingimage",
    DeleteUploadImage: BusinessID + "/websitebuilders/deleteuploadfile",
    SaveUpdateGeneralSettings: BusinessID + "/websitebuilders/saveupdategeneralsettings",
    DeactivateWebsiteBuilder: BusinessID + "/domainprocess/activatedeactivewebsitebuilder",
  };

  const FaviconImageSize = {
    width: 32,
    height: 32
  }

  const WebClipImageSize = {
    width: 256,
    height: 256
  }

  const readFile = (file, onLoadCallback) => {
    var reader = new FileReader();
    reader.onload = onLoadCallback;
    reader.readAsDataURL(file);
  };
  const imageSize = (filename, callback) => {

    var img = new Image();
    img.onload = function () {
        var myResult = {
            width: img.width,
            height: img.height,
        };
        callback(myResult);
    };
    img.src = filename;
    img.onerror = function () {
        var myResult = {
            width: -101,
            height: -101,
        };
        callback(myResult);
    };
  };

  const [analyticId, setAnalyticId] = useState("");
  const [headCode, setHeadCode] = useState("");
  const [footerCode, setFooterCode] = useState("");
  const [favicon, setFavicon] = useState("");
  const [webClip, setWebClip] = useState("");
  const [isLoading, setLoading] = useState(false);
  const [IsMessageOpen, setIsMessageOpen] = useState(false);
  const [Message, setMessage] = useState("");
  const [isValidGoogleAnalyticID, setisValidGoogleAnalyticID] = useState(true);

  const CheckSession = async () => {
    setLoading(true);
    return await useSession(dispatch, BusinessID, UserID, (data) => {
      setLoading(false);
      if (data == true) {
        GetGeneralSettings();
      }
    });
  }

  useEffect(() => {
    utils.SetPageTitle("General Setting");
    CheckSession();
  }, [BusinessID]);

  useEffect(() => {
    if (IsMessageOpen) {
      window.setTimeout(() => {
        setIsMessageOpen(false);
      }, 3000);
    }
  }, [IsMessageOpen]);


  const UploadImageReq = (
    filename,
    Base64
  ) => {
    const Requestdata = {};
    Requestdata.FileName = filename;
    Requestdata.base64image = "url(\"data:image/png;base64," + Base64 + "\")";
    Requestdata.Foldername = "Websitebuilder/";
    return Requestdata;
  };

  const FaviconUploadImage = async (
    filename,
    Base64,
    height, 
    width,
    filesDetails,
    divMain

  ) => {
    var isvalid = false;
    const access_token = await useGenerateToken(dispatch);
    readFile(filesDetails, function (e) {
      imageSize(e.target.result, function () {
        if (height === -101 && width === -101) {
          const TitleEnum = "Alert!";
          const BodyEnum =
            "The image you have uploaded seems to be corrupted. Please upload another image.";
          utils.ShowAlert(TitleEnum, BodyEnum, "OpenDialog2");
        } else if (
          (height === FaviconImageSize.height && width === FaviconImageSize.width && height <= FaviconImageSize.height && width <= FaviconImageSize.width) ||
          (height === FaviconImageSize.height && width === FaviconImageSize.width)
        ) {
          isvalid = true;
        } else {
          const TitleEnum = "Incorrect Image Size";
          const BodyEnum = `The width and height required for the image is ${FaviconImageSize.width}x${FaviconImageSize.height}`;
          utils.ShowAlert(TitleEnum, BodyEnum, "OpenDialog2");
        }
        if (isvalid) {
          if (utils.Validate(access_token)) {
            setLoading(true);
            const Requestdata = UploadImageReq(
              filename,
              Base64
            );
            AsyncAjaxPost(
              VagaroAPIEnum.GetUploadImage,
              Requestdata,
              access_token,
              function onSuccess(data) {
                try {
                  if (data != null && data.data != null && data.data.data != null) {
                    setFavicon(data.data.data);
                  }
                  setLoading(false);
                } catch (error) {
                  setLoading(false);
                }
              },
              function OnError() {
                setLoading(false);
              }
            );
          }
          else {
            utils.ShowAlert("Message", "Please reload this page and try again.", "OpenDialog");
          }
        }
      });
    });
  };

  const SaveFaviconUploadImage = (filename, Base64, height, width, filesDetails, divMain) => {
    FaviconUploadImage(filename, Base64, height, width, filesDetails, false);
  };

  const PopupClose = () => {
    unmountComponentAtNode(document.getElementById("OpenDialog"));
  };
  const EditStyleImageConfirmation = (fromClass) => {
    const Element = document.querySelector(`#generalupload.${fromClass}`)
    if (Element) { 
      Element.click()
    }
  }
  const DeleteFaviconImageConfirmation = (filename) => {
    return ReactDom.render(
      <VGPopUp
        id={"DeleteFaviconImage"}
        show={true}
        onHide={PopupClose}
        title={"Delete Favicon Image"}
        dialogClassName="cancelauto-renew-alert"
        body={
          <div className="alertContent">
            <p>Your favicon image will be removed from the database. Are you sure you want to remove image?</p>
          </div>
        }
        footer={
          <Fragment>
            <button className="w-button w-button-secondary" onClick={() => PopupClose()}>Cancel</button>
            <button className="w-button w-button-destructive-outline" onClick={() => DeleteFaviconImage(filename)}>Delete</button>
          </Fragment >
        }
        isRemoveTabModalIndex={false}
        isShowFooter={true}
        size={"modal-sm"}
        backdrop={true}
      />,
      document.getElementById("OpenDialog"));
  }

  const DeleteFaviconImage = async (
    filename
  ) => {
    const access_token = await useGenerateToken(dispatch);
    if (utils.Validate(access_token)) {
      PopupClose();
      setLoading(true);
      const Requestdata = {};
      Requestdata.FileName = filename;
      Requestdata.Foldername = "Websitebuilder";
      await AsyncAjaxPost(
        VagaroAPIEnum.DeleteUploadImage,
        Requestdata,
        access_token,
        function onSuccess(data) {
          try {
            if (data !== null && data.data !== null && data.data.data !== null && data.data.data === true) {
              setFavicon("");
            }
            setLoading(false);
          } catch (error) {
            setLoading(false);
          }
        },
        function OnError() {
          setLoading(false);
        }
      );
    }
    else {
      utils.ShowAlert("Message", "Please reload this page and try again.", "OpenDialog");
    }
  };

  const WebClipUploadImage = async (
    filename,
    Base64,
    height, 
    width,
    filesDetails,
    divMain
  ) => {
    var isvalid = false;
    const access_token = await useGenerateToken(dispatch);
    readFile(filesDetails, function (e) {
      imageSize(e.target.result, function () {
        if (height === -101 && width === -101) {
          const TitleEnum = "Alert!";
          const BodyEnum =
            "The image you have uploaded seems to be corrupted. Please upload another image.";
          utils.ShowAlert(TitleEnum, BodyEnum, "OpenDialog2");
        } else if (
          (height === WebClipImageSize.height && width === WebClipImageSize.width  && height <= WebClipImageSize.height && width <= WebClipImageSize.width) ||
          (height === WebClipImageSize.height && width === WebClipImageSize.width)
        ) {
          isvalid = true;
        } else {
          const TitleEnum = "Incorrect Image Size";
          const BodyEnum = `The width and height required for the image is ${WebClipImageSize.width}x${WebClipImageSize.height}`;
          utils.ShowAlert(TitleEnum, BodyEnum, "OpenDialog2");
        }
        if (isvalid) {
          if (utils.Validate(access_token)) {
            setLoading(true);
            const Requestdata = UploadImageReq(
              filename,
              Base64
            );
            AsyncAjaxPost(
              VagaroAPIEnum.GetUploadImage,
              Requestdata,
              access_token,
              function onSuccess(data) {
                try {
                  if (data != null && data.data != null && data.data.data != null) {
                    setWebClip(data.data.data);
                  }
                  setLoading(false);
                } catch (error) {
                  setLoading(false);
                }
              },
              function OnError() {
                setLoading(false);
              }
            );
          }
          else {
            utils.ShowAlert("Message", "Please reload this page and try again.", "OpenDialog");
          }
        }
      });
    });
  };

  const DeleteWebClipImageConfirmation = (filename) => {
    return ReactDom.render(
      <VGPopUp
        id={"DeleteFaviconImage"}
        show={true}
        onHide={PopupClose}
        title={"Delete Webclip Image"}
        dialogClassName="cancelauto-renew-alert"
        body={
          <div className="alertContent">
            <p>Your webclip image will be removed from the database. Are you sure you want to remove image?</p>
          </div>
        }
        footer={
          <Fragment>
            <button className="w-button w-button-secondary" onClick={() => PopupClose()}>Cancel</button>
            <button className="w-button w-button-destructive-outline" onClick={() => DeleteWebclipImage(filename)}>Delete</button>
          </Fragment >
        }
        isRemoveTabModalIndex={false}
        isShowFooter={true}
        size={"modal-sm"}
        backdrop={true}
      />,
      document.getElementById("OpenDialog"));
  }

  const DeleteWebclipImage = async (
    filename
  ) => {
    const access_token = await useGenerateToken(dispatch);
    if (utils.Validate(access_token)) {
      PopupClose();
      setLoading(true);
      const Requestdata = {};
      Requestdata.FileName = filename;
      Requestdata.Foldername = "Websitebuilder";
      await AsyncAjaxPost(
        VagaroAPIEnum.DeleteUploadImage,
        Requestdata,
        access_token,
        function onSuccess(data) {
          try {
            if (data !== null && data.data !== null && data.data.data !== null && data.data.data === true) {
              setWebClip("");
            }
            setLoading(false);
          } catch (error) {
            setLoading(false);
          }
        },
        function OnError() {
          setLoading(false);
        }
      );
    }
    else {
      utils.ShowAlert("Message", "Please reload this page and try again.", "OpenDialog");
    }
  };

  const SaveWebClip = (filename, Base64, height, width, filesDetails, divMain) => {
    WebClipUploadImage(filename, Base64, height, width, filesDetails, false);
  };

  const GetGeneralSettings = async () => {
    const access_token = await useGenerateToken(dispatch);
    if (utils.Validate(access_token)) {
      setLoading(true);
      await AsyncAjaxGet(
        VagaroAPIEnum.GetGeneralSettings,
        access_token,
        function onSuccess(data) {
          try {
            if (
              data != null &&
              data.data != null &&
              data.data.responseCode == ResponseCode.Success
            ) {
              if (data != null && data.data != null && data.data.data != null) {
                var generaldata = data.data.data;
                setAnalyticId(generaldata.google_analytics_id);
                setHeadCode(generaldata.head_code);
                setFooterCode(generaldata.footer_code);
                setWebClip(generaldata.webclip);
                setFavicon(generaldata.faviconLogo);
              } else {
                setAnalyticId("");
                setHeadCode("");
                setFooterCode("");
                setWebClip("");
                setFavicon("");
              }
            }
            setLoading(false);
          } catch (error) {
            setLoading(false);
            utils.appInsightTrack(
              ReactBusinessId,
              ReactUserID,
              "Get General Settings",
              BusinessID,
              ""
            );
          }
        },
        function OnError(error) {
          setLoading(false);
          utils.appInsightTrack(
            ReactBusinessId,
            ReactUserID,
            "Get General Settings",
            BusinessID,
            ""
          );
        }
      );
    }
    else {
      utils.ShowAlert("Message", "Please reload this page and try again.", "OpenDialog");
    }
  };

  const SaveGeneralSettings = async (isShowMessage) => {
    const access_token = await useGenerateToken(dispatch);

    let saveComplete = () => { }
    if (props.onSaveComplete) {
      saveComplete = () => { setTimeout(() => props.onSaveComplete(), 500) };
    }
    if (isValidGoogleAnalyticID === false) {
      return;
    }
    if (analyticId.slice(0, 2).includes("G-") || analyticId.slice(0, 3).includes("GT-") || analyticId === "") {
      setisValidGoogleAnalyticID(true);
    } else {
      setisValidGoogleAnalyticID(false);
      return;
    }
    if (utils.Validate(access_token)) {
      setLoading(true);
      const Requestdata = {};
      Requestdata.GoogleAnalyticsId = analyticId;
      Requestdata.HeadCode = headCode;
      Requestdata.WebClip = webClip;
      Requestdata.FooterCode = footerCode;
      Requestdata.FaviconLogo = favicon;
      Requestdata.CreatedBy = ReactUserID;
      await AsyncAjaxPost(
        VagaroAPIEnum.SaveUpdateGeneralSettings,
        Requestdata,
        access_token,
        function onSuccess(data) {
          try {
            if (
              data != null &&
              data.data != null &&
              data.data.responseCode == ResponseCode.Success
            ) {
              if (
                data != null &&
                data.data != null &&
                data.data.data != null &&
                data.data.data.status === true
              ) {
                GetGeneralSettings();
                setLoading(false);
                saveComplete();
                if (isShowMessage) {
                  setIsMessageOpen(true);
                  
                  setMessage("General Setting has been saved.");
                }
              } else {
                setLoading(false);
                saveComplete();
              }
            } else {
              setLoading(false);
              saveComplete();
            }
          } catch (error) {
            setLoading(false);
        
            utils.appInsightTrack(
              ReactBusinessId,
              ReactUserID,
              "Save/Update General Setting",
              Requestdata,
              ""
            );
          }
        },
        function OnError() {
          setLoading(false);
          
          utils.appInsightTrack(
            ReactBusinessId,
            ReactUserID,
            "Save/Update General Setting",
            Requestdata,
            ""
          );
        }
      );
    }
    else {
      utils.ShowAlert("Message", "Please reload this page and try again.", "OpenDialog");
    }
  };

  const DeactivateWebsiteBuilderPopup = () => {
    return ReactDom.render(
      <VGPopUp
        id={"DeactivateWebsiteBuilderPopup"}
        show={true}
        onHide={PopupClose}
        title={"Deactivate Website Builder"}
        dialogClassName="cancelauto-renew-alert"
        body={
          <div className="alertContent">
            <p>Deactivating the website builder will make your website be unaccessible online, and you will no longer be charged.</p>
          </div>
        }
        footer={
          <Fragment>
            <button className="w-button w-button-secondary" onClick={() => PopupClose()}>Cancel</button>
            <button className="w-button w-button-destructive-outline" onClick={() => DeactivateWebsiteBuilder()}>Deactivate</button>
          </Fragment >
        }
        isRemoveTabModalIndex={false}
        isShowFooter={true}
        size={"md"}
        backdrop={true}
      />,
      document.getElementById("OpenDialog"));
  }

  const AmplitudeAfterDomainDeactivate = async () => {
    const access_token = await useGenerateToken(dispatch);
    var logobject = {};
    logobject.PageURL = window.location.href;
    logobject.Step = 29;
    logobject.UserAgent = (navigator.userAgent).toLowerCase();
    logobject.UserID = ReactUserID;
    logobject.BusinessID = AmplitudeBusinessID;
    logobject.MySiteURL = BuildInDomain + "/" + VagaroURL;
    logobject.CountryID = CountryID;
    logobject.accessToken = access_token;

    await AddLogInAmplitude(logobject);
  };
  const footerCodeValidation = (Description) => {
    setFooterCode(Description);
  }

  const headCodeValidation = (Description) => {
    setHeadCode(Description);
  }

  const googleAnalyticsIdsValidation = (Description) => {
    setAnalyticId(Description);
    if (Description == "") {
      setisValidGoogleAnalyticID(true);
    }
    else {
      if (Description.slice(0, 2).includes("G-") || Description.slice(0, 3).includes("GT-")) {
        setisValidGoogleAnalyticID(true);
      } else {
        setisValidGoogleAnalyticID(true);
      }
      setAnalyticId(Description);
    }
  }

  const DeactivateWebsiteBuilder = async () => {
    AmplitudeAfterDomainDeactivate();
    const access_token = await useGenerateToken(dispatch);
    if (utils.Validate(access_token)) {
      setLoading(true);
      const Requestdata = {};
      Requestdata.isnewcustomwebsite = false;
      Requestdata.userId = ReactUserID
      await AsyncAjaxPost(
        VagaroAPIEnum.DeactivateWebsiteBuilder,
        Requestdata,
        access_token,
        function onSuccess(data) {
          try {
            if (
              data != null &&
              data.data != null &&
              data.data.responseCode == ResponseCode.Success
            ) {
              if (
                data != null &&
                data.data != null &&
                data.data.data != null &&
                data.data.data.status === true
              ) {
                PopupClose();
                setLoading(false);
                setIsMessageOpen(true);
                setMessage("Website builder has been deactivated.");
                dispatch(DeactivateWB());
              } else {
                setLoading(false);
                PopupClose();
              }
            } else {
              setLoading(false);
              PopupClose();
            }
          } catch (error) {
            setLoading(false);
            PopupClose();
            utils.appInsightTrack(
              ReactBusinessId,
              ReactUserID,
              "Deactivate WebsiteBuilder",
              Requestdata,
              ""
            );
          }
        },
        function OnError() {
          PopupClose();
          setLoading(false);
          utils.appInsightTrack(
            ReactBusinessId,
            ReactUserID,
            "Deactivate WebsiteBuilder",
            Requestdata,
            ""
          );
        }
      );
    }
    else {
      utils.ShowAlert("Message", "Please reload this page and try again.", "OpenDialog");
    }
  };


  return (
    <div
      className={
        props.hidePannel ? "" :
          ReactBusinessId <= 0
            ? "all-content-container no-access-main-content-wrapper"
            : "all-content-container main-content-wrapper"
      }
    >
      {/* import left panel */}
      {!props.hidePannel &&
        <Leftpanel
          activateTab={"GeneralSetting"}
          activatePage={"GeneralSetting"}
        />}
      {(() => {
        if (ReactBusinessId === 0 || typeof ReactBusinessId === 'undefined') {
          return (
            <Fragment>
              <NoRights onCancel={props.onCancel} />
            </Fragment>
          );
        } else {
          return (
            <Fragment>
              {props.hidePannel &&
                <div className="page-title title-with-actions" style={{ position: "sticky", top: "0", background: "white", zIndex: "100", paddingLeft: "12px" }}>
                    General

                    {IsNewCustomWebSite &&
                      <div className="inline-actions-btns">
                        <button
                          className="w-button w-button-destructive-outline"
                          onClick={() => { IsModifyAllowed ? DeactivateWebsiteBuilderPopup() : utils.ShowAlert("Alert", "You do not have permission to deactivate website builder.", "OpenDialog")  }}>
                          Deactivate Website Builder
                        </button>
                      </div>
                    }
                  </div>
                }
              <div className="page-root">
                {(() => {
                  if (ReactBusinessId === 0 || typeof ReactBusinessId === 'undefined') {
                    return <NoRights onCancel={props.onCancel} />;
                  } else {
                    return (
                      ReactBusinessId > 0 &&
                      <Fragment>
                        {isLoading && <Loader />}
                        <div className="page-content container">
                          {IsMessageOpen && (
                            <Alert
                              isOpen={IsMessageOpen}
                              variant="success"
                              className="vg-alert-strip vg-passive"
                            >
                              <i class="fas fa-check-circle"></i> {Message}
                            </Alert>
                          )}
                          {!props.hidePannel &&
                            
                            <div className="page-title title-with-actions">
                            General

                            {IsNewCustomWebSite &&
                              <div className="inline-actions-btns">
                                <button
                                  className="w-button w-button-destructive-outline"
                                  onClick={() => DeactivateWebsiteBuilderPopup()}>
                                  Deactivate Website Builder
                                </button>
                              </div>
                            }
                          </div>
                  }
                          <Form className="form-content">
                            <Form.Group className={`form-row`}>
                              <Form.Label>Favicon:</Form.Label>
                              <div className="form-text">
                                Upload a 32 x 32 pixel ICO, PNG, GIF, or JPG to
                                display in browser tabs.
                              </div>
                              <div>
                                {utils.Validate(favicon) &&
                                  <div className="drop-file-upload py-t8 uploaded" style={{ backgroundImage: `url('${CDNURL + "Websitebuilder/" + favicon}')` }}>
                                  <div className="showdelete d-flex flex-column">
                                    <div className="p-2">
                                        <a onClick={() => EditStyleImageConfirmation("inpFavicon")}>Edit</a>
                                    </div>
                                    <div className="p-2">
                                          <a onClick={() => DeleteFaviconImageConfirmation(favicon)}>Delete</a>
                                    </div>
                                        </div>
                                  </div>
                                }
                                <div className={`drop-file-upload py-t8`} style={{ display: favicon !== "" ? "none" : "flex" }} >
                                    <i className="far fa-cloud-upload" />
                                    <span className="upload-note">
                                      Drag and drop files here or
                                    </span>
                                    <span className="upload-trigger">
                                      Choose File
                                    </span>
                                    <FileUpload
                                      id="generalupload"
                                      className={"inpFavicon"}
                                      height={FaviconImageSize.height}
                                      width={FaviconImageSize.width}
                                      Message="Maximum Width and Height required 32X32"
                                      ValidFileExtensionMessage="Upload a valid PNG, HEIC, JPEG or JPG image."
                                      FileExtension="/(ico|gif|png|jpg|jpeg|ICO|GIF|PNG|JPG|JPEG)$/i"
                                      savecdn={SaveFaviconUploadImage}
                                      setLoading={setLoading}
                                    ></FileUpload>
                                  </div>
                              </div>
                            </Form.Group>
                            <Form.Group className={`form-row`}>
                              <Form.Label>Webclip:</Form.Label>
                              <div className="form-text">
                                Upload a 256 x 256 pixel webclip image. This
                                icon shows up when your website link is saved to
                                an iPhone home screen.
                              </div>
                              {utils.Validate(webClip) &&
                                <div className="drop-file-upload py-t8 uploaded" style={{ backgroundImage: `url('${CDNURL + "Websitebuilder/" + webClip}')` }}>
                                   <div className="showdelete d-flex flex-column">
                                    <div className="p-2">
                                        <a onClick={() => EditStyleImageConfirmation("inpWebclip")}>Edit</a>
                                    </div>
                                    <div className="p-2">
                                        <a onClick={() => DeleteWebClipImageConfirmation(webClip)}>Delete</a>
                                    </div>
                                  </div>
                                </div>
                                }
                              <div className={`drop-file-upload webclip py-t8`} style={{ display: webClip !== "" ? "none" : "flex" }}>
                                  <i className="far fa-cloud-upload" />
                                  <span className="upload-note">
                                    Drag and drop files here or
                                  </span>
                                  <span className="upload-trigger">
                                    Choose File
                                  </span>
                                  <FileUpload
                                    id="generalupload"
                                    className={"inpWebclip"}
                                    height={WebClipImageSize.height}
                                    width={WebClipImageSize.width}
                                    Message="Maximum Width and Height required 256X256"
                                    ValidFileExtensionMessage="Upload a valid PNG, HEIC, JPEG or JPG image."
                                    FileExtension="/(gif|png|jpg|jpeg|GIF|PNG|JPG|JPEG)$/i"
                                    savecdn={SaveWebClip}
                                    setLoading={setLoading}
                                  ></FileUpload>
                                </div>
                            </Form.Group>
                            <Form.Group className={`form-row ${!isValidGoogleAnalyticID && "form-row-invalid"}`}>
                              <Form.Label>Google Analytics ID:</Form.Label>
                              <Form.Control
                                type="text"
                                maxLength={15}
                                placeholder="Should start with a “G-” or “GT-”"
                                defaultValue={analyticId}
                                value={analyticId}
                                onChange={(e) => {
                                  googleAnalyticsIdsValidation(e.target.value);
                                }}
                              />
                              {!isValidGoogleAnalyticID && <Form.Control.Feedback type="invalid">Please enter valid Google Analytics ID which starts with "G-" or "GT-"</Form.Control.Feedback>}
                            </Form.Group>
                            <Form.Group className={`form-row`}>
                              <Form.Label>Head Code:</Form.Label>
                              <Form.Control
                                as="textarea"
                                maxLength={5000}
                                rows={3}
                                placeholder="Enter code"
                                defaultValue={headCode}
                                value={headCode}
                                onChange={(e) => {
                                  headCodeValidation(e.target.value);
                                }}
                              />
                            </Form.Group>
                            <Form.Group className={`form-row`}>
                              <Form.Label>Footer Code:</Form.Label>
                              <Form.Control
                                as="textarea"
                                maxLength={5000}
                                rows={3}
                                placeholder="Enter code"
                                defaultValue={footerCode}
                                value={footerCode}
                                onChange={(e) => { footerCodeValidation(e.target.value) }}
                              />                              
                            </Form.Group>
                          </Form>
                          <div className="page-title title-with-actions actions-bottoms">
                            <div className="inline-actions-btns">

                              {props.onCancel &&
                                <button
                                  className="w-button w-button-secondary"
                                  onClick={() => props.onCancel()}
                                >
                                  Cancel
                                </button>

                              }

                              <button
                            
                                className="w-button w-button-primary close-on-click"
                                onClick={() => IsModifyAllowed ? isValidGoogleAnalyticID ? SaveGeneralSettings(true) : "" : utils.ShowAlert("Alert", "You do not have access to save general settings.", "OpenDialog")}
                              >
                                Save
                              </button>
                            </div>
                          </div>
                        </div>
                      </Fragment>
                    );
                  }
                })()}
              </div>
            </Fragment>
          );
        }
      })()}
    </div>
  );
};

export default GeneralSettings;
